import React from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-web';
import { textSecondary_7_0 } from '../TextComponent/TextStyle';
import LargeBtnWithFilling from '../ButtonComponent/LargeBtnWithFilling';
import InputField from '../../../ManulRecipient/InputField';

//= ========================================================================
const InputTextOverBtn = ({
  globJSON,
  inputText,
  subCategoryId,
  simPlatform,
  withSubCategory,
  withPrimaryColor,
  marginTop,
  isLoan,
}) => {
  const subCategory = globJSON.configurations.services[subCategoryId];
  const step = isLoan ? subCategory.number : subCategory.reference;
  return (
    <View>
      {withSubCategory
            && (
            <Text
              style={[textSecondary_7_0(globJSON, simPlatform), {
                paddingVertical: '1%',
                height: 12,
                marginLeft: 28,
              }]}
            >
              {isLoan ? step.enter_number_installments : step.enter_free_text}
            </Text>
            )}
      <View style={{ width: 198, alignSelf: 'center', marginTop: isLoan && 10 }}>
        <InputField
          globJSON={globJSON}
          inputText={inputText}
          isFormFilled={withPrimaryColor}
        />
      </View>
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        inputText={step.next}
        marginTop={marginTop}
      />
    </View>
  );
};
export default InputTextOverBtn;
